import { Controller } from "@hotwired/stimulus"
import { swipeableMixin } from "./mixins/swipeable"

/**
 * Notification Swipe Controller - iOS Mail-style swipe-to-delete
 *
 * Uses shared swipeable mixin for touch handling.
 * Adds notification-specific delete action via Turbo Stream.
 *
 * Usage:
 * <div data-controller="notification-swipe"
 *      data-notification-swipe-notification-id-value="123"
 *      data-notification-swipe-delete-url-value="/notifications/123"
 *      data-notification-swipe-threshold-value="50"
 *      data-notification-swipe-delete-width-value="80">
 *   <a data-notification-swipe-target="card">...</a>
 *   <div data-notification-swipe-target="deleteAction">
 *     <button data-action="click->notification-swipe#delete">Delete</button>
 *   </div>
 * </div>
 */
export default class extends Controller {
  static targets = ["card", "deleteAction"]
  static values = {
    notificationId: Number,
    deleteUrl: String,  // Rails route helper로 전달
    threshold: { type: Number, default: 50 },
    deleteWidth: { type: Number, default: 80 }
  }

  connect() {
    swipeableMixin.setup(this)
  }

  disconnect() {
    swipeableMixin.teardown(this)
  }

  /**
   * Delete notification via Turbo Stream
   * URL은 ERB에서 Rails route helper로 주입
   */
  delete(event) {
    event.preventDefault()
    event.stopPropagation()

    const deleteUrl = this.deleteUrlValue
    if (!deleteUrl) {
      console.error('notification-swipe: deleteUrl value is required')
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(deleteUrl, {
      method: 'DELETE',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': csrfToken
      }
    }).then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error('Delete failed')
    }).then(html => {
      Turbo.renderStreamMessage(html)
    }).catch(error => {
      console.error('Failed to delete notification:', error)
      swipeableMixin.resetPosition(this)
    })
  }
}
